export default __webpack_public_path__ + "static/media/Group 3205.11586c23.jpg";